import * as React from "react";
import { Form, Segment, Grid, Header, List, Checkbox, Table, Dropdown, Message, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell, GridRow, GridColumn, FormField, ListItem, FormGroup, FormInput, MessageHeader, MessageList, MessageItem, FormTextArea } from "@/components/bp/bp-ui";
import { Formik, Field, FormikProps } from "formik";
import * as yup from "yup";
import { CaseRunCreateEvidenceModelWithSystems, EvidenceClient, MaxLrCaseRunCreateModelBase, SampleClient } from "@app/api2/api";
import SemanticField from "@app/components/SemanticField";
import { concat, groupBy, sortBy, uniqBy } from "lodash";
import { selectMany } from "@common/Utils";
import { Constants } from "./Constants";
import { TranslationContext } from "../Contexts/TranslationContext";
import { BPButton } from "@/components/bp/bpbutton";
import { BPCheckbox } from "@/components/bp/bpcheckbox";

interface IInformactionMaxLrProps {
    model: MaxLrCaseRunCreateModelBase;
    onComplete: (values: any) => void;
    router: any;
    rangeOfContributors: boolean;
    rangeOfContributorsToggable?: boolean;
}


export type MaxLrFormType = Omit<MaxLrCaseRunCreateModelBase, 'hdUnknowns' | 'hpUnknowns' | 'parameters'> & {
    hdUnknowns: number | string;
    hpUnknowns: number | string;
    rangeOfContributorsMin: number;
    rangeOfContributorsMax: number;
    calcAicIndependently: boolean;
    allowVariableNoC: boolean;
};

class InformactionMaxLrState {
    initialValues: MaxLrFormType;
    populationOptions: any[];
    isRangeOfContributors: boolean;

    evSystems: { [id: number]: { name: string, selected: boolean }[] } = {};
    contrSystems: { [id: number]: { name: string, selected: boolean }[] } = {};
    isAllSystemsSelected: boolean = false;
    allSelectedSystems: Array<string> = [];
    selectedContrs: Array<number> = [];
    selectedEvids: Array<number> = [];

    // allSystems: string[] = [];

    // allowVariableNoc: boolean;
}


export class InformactionMaxLr extends React.Component<IInformactionMaxLrProps, InformactionMaxLrState> {
;

    InformactionMaxLrValidationSchema: yup.AnyObjectSchema;

    InformactionMaxLrRangeValidationSchema: yup.AnyObjectSchema;
    form: any = React.createRef();

    sampleClient = new SampleClient()
    evidenceClient = new EvidenceClient()

    constructor(props, context) {
        super(props, context);

        let parsed = this.parseNumberOfContributors(this.props.model.numberOfContributors);

        let $this = this;

        this.InformactionMaxLrValidationSchema = yup.object().shape({
            description: yup.string().label(window.translation.caseRun.runDescription),
            hdUnknowns: this.props.model.useHd ? yup.number().min(0).integer().max(Constants.maxUnknowns).required().label(window.translation.caseRun.hdUnknowns) : yup.number(),
            hpUnknowns: this.props.model.useHp ? yup.number().min(0).integer().max(Constants.maxUnknowns).required().label(window.translation.caseRun.hpUnknowns) : yup.number(),
            populationId: yup.number().required().label(window.translation.common.population)
        });

        this.InformactionMaxLrRangeValidationSchema = yup.object().shape({
            description: yup.string().label(window.translation.caseRun.runDescription),
            rangeOfContributorsMin: yup.number().min(1).integer().max(Constants.maxNoc).required().label(window.translation.caseRun.rangeOfContributors),
            rangeOfContributorsMax: yup.number().min(1).integer().max(Constants.maxNoc).required().label(window.translation.caseRun.rangeOfContributors),

            hdUnknowns: yup.string().required().label(window.translation.caseRun.hdUnknowns).test('hdUnknowns', window.translation.caseRun.numberOfContributorsError, function (value) {
                const { path, createError } = this;

                let parsed = $this.parseNumberOfContributors(value);

                if (parsed.min < 0 || parsed.max < 0)
                    return false;

                return true;
            }),

            hpUnknowns: yup.string().required().label(window.translation.caseRun.hpUnknowns).test('hpUnknowns', "", function (value) {
                const { path, createError } = this;

                let parsed = $this.parseNumberOfContributors(value);

                if (parsed.min < 0 || parsed.max < 0)
                    return createError({ path, message: window.translation.caseRun.numberOfContributorsError });

                return true;
            }),

            someth: yup.string().label(window.translation.caseRun.hpUnknowns).test('someth', "", function (value) {
                const { path, createError } = this;

                if ($this.props.model.runType == 'deconv_main')
                    return true;

                let hp = $this.props.model.useHp ? $this.form.current.values.hp.filter(x => x.selected) : [];
                let hd = $this.props.model.useHd ? $this.form.current.values.hd.filter(x => x.selected) : [];
                let hpNotInHd = hp.filter(p => !hd.some(d => d.id == p.id));
                if (hpNotInHd.length! - 1) {
                    return createError({ path, message: window.translation.caseRun.onlyOnePoiCanBeSelectedError });
                }

                return true;
            }),
        });

        this.state = {
            initialValues: {
                description: this.props.model.description || "",
                numberOfContributors: this.props.model.numberOfContributors,
                hpNumberOfContributors: this.props.model.hpNumberOfContributors,
                hdNumberOfContributors: this.props.model.hdNumberOfContributors,
                hdUnknowns: !this.props.rangeOfContributors ? (this.props.model.hdUnknowns) : this.calcUnknownHx(parsed.min, parsed.max, this.props.model.hd),
                hpUnknowns: !this.props.rangeOfContributors ? (this.props.model.hpUnknowns) : this.calcUnknownHx(parsed.min, parsed.max, this.props.model.hp),
                populationId: this.props.model.populationId && this.props.model.populations.some(x => x.id == this.props.model.populationId) ? this.props.model.populationId : null,
                hd: this.props.model.hd,
                hp: this.props.model.hp,
                evidence: this.props.model.evidence,
                rangeOfContributorsMin: parsed ? parsed.min : 1,
                rangeOfContributorsMax: parsed ? parsed.max : 2,
                hdKnownRelName: this.props.model.hdKnownRelName,
                hdKnownRelSampleId: this.props.model.hdKnownRelSampleId,
                aic: this.props.model.aic,
                useHd: this.props.model.useHd,
                useHp: this.props.model.useHp,
                populations: this.props.model.populations,
                createdFromPrevious: this.props.model.createdFromPrevious,
                discriminator: this.props.model.discriminator,
                efmCaseId: this.props.model.efmCaseId,
                labId: this.props.model.labId,
                oldRunId: this.props.model.oldRunId,
                sampleSystems: this.props.model.sampleSystems,
                evidenceSystems: this.props.model.evidenceSystems,
                hasSelectedSystems: this.props.model.hasSelectedSystems,
                calcAicIndependently: this.props.model.parameters.find(x => x.parameter == "calcAicIndependently")?.value == "1",
                allowVariableNoC: this.props.model.parameters.find(x => x.parameter == "allowVariableNoC")?.value == "1"
            },
            isRangeOfContributors: this.props.rangeOfContributors,
            populationOptions: this.props.model.populations.map((p) => ({ key: p.id, value: p.id, text: p.name })),
            contrSystems: this.props.model.sampleSystems?.reduce((prev, cur) => {
                prev[cur.id] = cur.systems.map(s => { return { name: s.name, selected: s.selected } })
                return prev
            }, {}),
            evSystems: this.props.model.evidenceSystems?.reduce((prev, cur) => {
                prev[cur.id] = cur.systems.map(s => { return { name: s.name, selected: s.selected } })
                return prev
            }, {}),
            isAllSystemsSelected: true,
            allSelectedSystems: [],
            selectedContrs: [],
            selectedEvids: [],
            // allowVariableNoc: !this.props.rangeOfContributors && (this.props.model.hd?.filter(x => x.selected).length ?? 0) + this.props.model.hdUnknowns != (this.props.model.hp?.filter(x => x.selected).length ?? 0) + this.props.model.hpUnknowns,
        };
    }

    parseNumberOfContributors = (noc: string) => {
        const sign = (noc || 0).toString().startsWith("-") ? "-" : "+";
        if (sign == "-")
            noc = noc.substring(1, noc.length);

        const range = noc != null ? noc.split("-") : null;

        if (range && range.length > 0) {
            // if (sign == "-")
            //     range
            const min = parseInt(range[0]) * (sign == "-" ? -1 : 1);
            const max = parseInt(range[range.length - 1]);

            return { min: Math.min(min, max), max: Math.max(min, max) };
        }

        return { min: 1, max: 2 };
    };

    calcUnknownHx = (nocMin: number, nocMax: number, contributors: Array<{ selected: boolean }>) => {
        let unknowns = [];
        for (let noc = nocMin; noc <= nocMax; noc++) {
            let unknown = noc;
            //let hd = values.hd;
            //let hp = values.hp;
            unknown = noc - (contributors || []).filter(h => h.selected).length;
            unknowns.push(unknown);
        }
        return unknowns.join("-");
    }

    formRender = ({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldTouched, setFieldValue }: FormikProps<MaxLrFormType>) => {
        // const handleChange_ = (e) => handleChange(e);
        // var state = this.state;
        const dropdownChange = async (e, data, name?) => {
            if (name) {
                await setFieldValue(name, data.value);
                if (name == "numberOfContributors") {
                    await setFieldValue("hpNumberOfContributors", data.value);
                    await setFieldValue("hdNumberOfContributors", data.value);

                    await recalcUnknownHd(data.value, data.value);
                    await recalcUnknownHp(data.value, data.value);
                }
                if (name == "hpNumberOfContributors") {
                    // recalcUnknownHd(data.value, data.value);
                    await recalcUnknownHp(data.value, data.value);
                }
                if (name == "hdNumberOfContributors") {
                    await recalcUnknownHd(data.value, data.value);
                    // recalcUnknownHp(data.value, data.value);
                }

            } else {
                await setFieldValue("populationId", data.value);
            }
        };

        const recalc = async (min, max) => {
            await recalcUnknownHd(min, max);
            await recalcUnknownHp(min, max);

            const noc = min != max ? [min, max].join("-") : min;
            await setFieldValue("numberOfContributors", noc);
        }

        // const descriptionUpdate = (e, data) => {
        //     setFieldValue("description", data.value);
        // }

        const evidenceChecked = async (id: number, i: number, value) => {
            var evidence = values.evidence;
            evidence[i].selected = value;

            if (value) {
                let markers = await this.evidenceClient.getDetails(this.props.model.labId, this.props.model.efmCaseId, evidence[i].id)
                this.setState({ ...this.state, evSystems: { ...this.state.evSystems, [evidence[i].id]: markers.evidence.markers.map(m => { return { name: m.name, selected: true } }) } })
                // evidence[i].selectedSystems = markers.evidence.markers.map(x => x.name)
            } else {
                const { [evidence[i].id]: _, ...rest } = this.state.evSystems as any;
                // evidence[i].selectedSystems = []
                this.setState({ ...this.state, evSystems: rest })
            }
            await setFieldValue("evidence", evidence);
        }

        const hpChecked = async (id, i, value) => {
            const hp = values.hp;

            await setFieldValue("hp", hp);

            var currElem = hp[i];
            currElem.selected = value;

            if (!values.hd.find(x => x.id == currElem.id && x.selected)) {
                if (value) {
                    let markers = await this.sampleClient.getDetails(this.props.model.labId, this.props.model.efmCaseId, currElem.id)
                    // if (currElem.selectedSystems == null)
                    //     currElem.selectedSystems = markers.sample.markers.map(x => x.markerName)                
                    await setStateAsync({ ...this.state, contrSystems: { ...this.state.contrSystems, [currElem.id]: markers.sample.markers.map(m => { return { name: m.markerName, selected: true } }) } })
                } else {
                    const { [currElem.id]: _, ...rest } = this.state.contrSystems as any;
                    // currElem.selectedSystems = []
                    await setStateAsync({ ...this.state, contrSystems: rest })
                }
            }

            if (!this.state.isRangeOfContributors)
                await recalcUnknownHp(values.allowVariableNoC ? values.hpNumberOfContributors : values.numberOfContributors, values.allowVariableNoC ? values.hpNumberOfContributors : values.numberOfContributors)
            else
                await recalcUnknownHp(values.rangeOfContributorsMin, values.rangeOfContributorsMax)

        }

        const hdChecked = async (id, i, value) => {
            var hd = values.hd;
            var currElem = hd[i];
            currElem.selected = value;

            await setFieldValue("hd", hd);

            if (!values.hp.find(x => x.id == currElem.id && x.selected)) {
                if (value) {
                    let markers = await this.sampleClient.getDetails(this.props.model.labId, this.props.model.efmCaseId, currElem.id)
                    // if (currElem.selectedSystems == null)
                    //     currElem.selectedSystems = markers.sample.markers.map(x => x.markerName)
                    await setStateAsync({ ...this.state, contrSystems: { ...this.state.contrSystems, [currElem.id]: markers.sample.markers.map(m => { return { name: m.markerName, selected: true } }) } })

                } else {
                    // currElem.selectedSystems = []

                    const { [currElem.id]: _, ...rest } = this.state.contrSystems as any;

                    await setStateAsync({ ...this.state, contrSystems: rest })
                }
            }

            if (!this.state.isRangeOfContributors)
                await recalcUnknownHd(values.allowVariableNoC ? values.hdNumberOfContributors : values.numberOfContributors, values.allowVariableNoC ? values.hdNumberOfContributors : values.numberOfContributors);
            else
                await recalcUnknownHd(values.rangeOfContributorsMin, values.rangeOfContributorsMax);

        }

        const setStateAsync = (state) => {
            return new Promise((resolve, reject) => {
                // setFieldValue('hdUnknowns', this.calcUnknownHx(nocMin, nocMax, values.hd));
                this.setState({ ...state }, () => resolve(null));
            });

        }

        const recalcUnknownHd = (nocMin, nocMax) => {
            return new Promise(async (resolve, reject) => {
                await setFieldValue('hdUnknowns', this.calcUnknownHx(nocMin, nocMax, values.hd));
                this.setState({ ...this.state }, () => resolve(null));
            });
        }

        const recalcUnknownHp = (nocMin, nocMax) => {
            return new Promise(async (resolve, reject) => {
                await setFieldValue('hpUnknowns', this.calcUnknownHx(nocMin, nocMax, values.hp));
                this.setState({ ...this.state }, () => resolve(null));
            });
        }

        const style = { 'maxHeight': '20vh', 'overflowY': 'auto' };

        const selectedEvidence = sortBy(values.evidence.filter(x => x.selected), x => `${x.name}_${x.id}`)
        const uniqueSelectedContributros = sortBy(uniqBy(concat(values.hp.filter(x => x.selected), values.hd.filter(x => x.selected)), x => x.id), x => `${x.name}_${x.id}`)
        // const selectedContributros = sortBy(concat(values.hp.filter(x => x.selected), values.hd.filter(x => x.selected)), x => `${x.name}_${x.id}`)
        const selectedContributrosG = sortBy(groupBy(concat(values.hp, values.hd), x => x.id), x => `${x.find(c => true).name}_${x.find(c => true).id}`).filter(x => x.find(xx => xx.selected) != null)
        // const selectedContributrosG = sortBy(groupBy(concat(values.hp.filter(x => x.selected), values.hd.filter(x => x.selected)), x => x.id), x => `${x.find(c => true).name}_${x.find(c => true).id}`)

        // const allContribs = concat(values.hp, values.hd)
        const allSystems = sortBy(uniqBy(concat(selectMany(Object.entries(this.state.evSystems).map(x => x[1]), x => x), selectMany(Object.entries(this.state.contrSystems), x => x[1])), x => x.name), x => x.name).map(x => x.name)
        // const d = {...[this.state.evSystems.entries()]}

        return (<TranslationContext.Consumer>{t =>
            <Form onSubmit={handleSubmit}>
                <SemanticField
                    name="description"
                    component={FormTextArea}
                    label={t.caseRun.runDescription} />

                <FormField>
                    <label>{t.common.population}</label>
                    <Dropdown search selection disabled={this.props.model.aic} options={this.state.populationOptions} value={values.populationId} onChange={dropdownChange} />
                </FormField>
                {this.props.rangeOfContributorsToggable &&
                    <FormField>
                        <Field
                            component={Checkbox}
                            label={t.parameter.names.isAIC}
                            onChange={(ev, val) => {
                                this.setState({ isRangeOfContributors: val.checked })
                            }}
                            checked={this.state.isRangeOfContributors} />
                    </FormField>
                }
                <Grid>
                    <GridRow columns={3}>
                        <GridColumn>
                            {this.props.model.useHp &&
                                <FormField>
                                    <label>{this.state.isRangeOfContributors ? t.caseRun.rangeOfContributors : t.caseRun.numberOfContributors}</label>
                                    {!values.allowVariableNoC && <>
                                        {this.state.isRangeOfContributors ? (
                                            <FormGroup>
                                                <FormInput name="rangeOfContributorsMin" value={values.rangeOfContributorsMin} onChange={(e, d) => { handleChange(e); recalc(d.value, values.rangeOfContributorsMax); }} width={3} />-<FormInput name="rangeOfContributorsMax" value={values.rangeOfContributorsMax} onChange={(e, d) => { handleChange(e); recalc(values.rangeOfContributorsMin, d.value); }} width={3} />
                                            </FormGroup>) : (
                                            <Dropdown search selection options={[...Array(Constants.maxNoc).keys()].map(i => (i + 1).toString()).map(m => { return { key: m, value: m, text: m }; })} value={values.numberOfContributors} onChange={(e, data) => dropdownChange(e, data, "numberOfContributors")} />
                                        )}</>}
                                    {values.allowVariableNoC &&
                                        <Dropdown search selection options={[...Array(Constants.maxNoc).keys()].map(i => (i + 1).toString()).map(m => { return { key: m, value: m, text: m }; })} value={values.hpNumberOfContributors} onChange={(e, data) => dropdownChange(e, data, "hpNumberOfContributors")} />
                                    }
                                </FormField>}
                        </GridColumn>
                        <GridColumn>
                            {this.props.model.useHd && values.allowVariableNoC &&
                                <FormField>
                                    <label>{t.caseRun.numberOfContributors}</label>
                                    <Dropdown search selection options={[...Array(Constants.maxNoc).keys()].map(i => (i + 1).toString()).map(m => { return { key: m, value: m, text: m }; })} value={values.hdNumberOfContributors} onChange={(e, data) => dropdownChange(e, data, "hdNumberOfContributors")} />
                                </FormField>}
                        </GridColumn>
                        <GridColumn>
                            <FormField>
                                <label></label>
                                {!this.props.rangeOfContributors &&
                                    <Field
                                        component={Checkbox}
                                        label={t.caseRun.allowVariableNoc}
                                        onChange={async (ev, val) => {
                                            await setFieldValue('allowVariableNoC', val.checked)
                                        }}
                                        checked={values.allowVariableNoC} />}
                                {this.props.rangeOfContributors &&
                                    <Field
                                        component={Checkbox}
                                        label={t.parameter.names['calcAicIndependently']}
                                        onChange={async (ev, val) => {
                                            await setFieldValue('calcAicIndependently', val.checked)
                                            // handleChange(ev);
                                        }}
                                        checked={values.calcAicIndependently} />}

                            </FormField>
                        </GridColumn>

                    </GridRow>
                </Grid>

                <Grid>
                    <GridRow columns={3}>
                        {this.props.model.useHp &&
                            <GridColumn>
                                <Header attached="top">{this.props.model.useHp && this.props.model.useHd ? t.caseRun.hpContributors : t.common.contributors}</Header>
                                <Segment attached>
                                    <div style={style as any}>
                                        <List relaxed divided>
                                            {values.hp.map((e, i) => (
                                                <ListItem key={e.id}>
                                                    <BPCheckbox disabled={this.props.model.aic} checked={e.selected} label={e.name} onClick={(ev, data) => (hpChecked(e.id, i, data.checked))} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                    <br />
                                    <FormField inline error={!!errors.hpUnknowns}>
                                        <label>{this.props.model.useHp && this.props.model.useHd ? t.caseRun.hpUnknowns : t.common.unknowns}</label>
                                        <Field name="hpUnknowns" readOnly={true} />
                                    </FormField>
                                </Segment>
                            </GridColumn>
                        }
                        {this.props.model.useHd &&
                            <GridColumn>
                                <Header attached="top">{t.caseRun.hdContributors}</Header>
                                <Segment attached>
                                    <div style={style as any}>

                                        <List relaxed divided>
                                            {values.hd.map((e, i) => (
                                                <ListItem key={e.id}>
                                                    <BPCheckbox disabled={this.props.model.aic} checked={e.selected} label={e.name} onClick={(ev, data) => (hdChecked(e.id, i, data.checked))} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div><br />
                                    <FormField inline error={!!errors.hdUnknowns}>
                                        <label>{t.caseRun.hdUnknowns}</label>
                                        <Field name="hdUnknowns" readOnly={true} />
                                    </FormField>
                                    <FormField>
                                        <label>{t.caseRun.firstUnknownRelation}</label>
                                        <Dropdown search selection options={Object.getOwnPropertyNames(t.relations).map(m => { return { key: m, value: m, text: t.relations[m] }; })} value={values.hdKnownRelName} onChange={(e, data) => dropdownChange(e, data, "hdKnownRelName")} />
                                    </FormField>
                                    <FormField>
                                        <label>to</label>
                                        <Dropdown search selection options={(values.hd as Array<any>).concat(values.hp).filter(x => x.selected).map(m => { return { key: m.id, value: m.id, text: m.name }; }).filter((value, index, self) => self.findIndex(c => c.key == value.key) === index)} value={values.hdKnownRelSampleId} onChange={(e, data) => dropdownChange(e, data, "hdKnownRelSampleId")} />
                                    </FormField>

                                </Segment>
                            </GridColumn>
                        }
                        <GridColumn>
                            <Header attached="top">{t.common.evidence}</Header>
                            <Segment attached>
                                <div style={style as any}>
                                    <List relaxed divided>
                                        {values.evidence.map((e, i) => (
                                            <ListItem key={e.id}>
                                                <BPCheckbox disabled={this.props.model.aic} checked={e.selected} label={e.name} onClick={(ev, data) => (evidenceChecked(e.id, i, data.checked))} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </Segment>
                        </GridColumn>
                    </GridRow>
                </Grid>
                {(selectedEvidence.length > 0 || selectedContributrosG.length > 0) &&
                    <Segment>
                        <SemanticField name="hasSelectedSystems" component={BPCheckbox} label={t.caseRun.customDataSelection}></SemanticField>
                        {/* <BPCheckbox onClick={(ev, data) => { }} /> */}
                        {values.hasSelectedSystems &&
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        <TableHeaderCell>
                                            <BPCheckbox
                                                checked={this.state.isAllSystemsSelected}
                                                label={window.translation.common.system}
                                                onChange={(evt, data) => {
                                                    this.setState({
                                                        ...this.state,
                                                        isAllSystemsSelected: data.checked,
                                                        allSelectedSystems: data.checked ? allSystems : [],
                                                        contrSystems: Object.entries(this.state.contrSystems).reduce((acc, entry) => ({
                                                            ...acc,
                                                            [entry[0]]: entry[1].map(s => {
                                                                s.selected = s.selected = data.checked;
                                                                return s;
                                                            })
                                                        }), {}),
                                                        evSystems: Object.entries(this.state.evSystems).reduce((acc, entry) => ({
                                                            ...acc,
                                                            [entry[0]]: entry[1].map(s => {
                                                                s.selected = s.selected = data.checked;
                                                                return s;
                                                            })
                                                        }), {}),
                                                    })
                                                }}></BPCheckbox></TableHeaderCell>
                                        {selectedEvidence.map(ev => {
                                            return <TableHeaderCell key={`ev${ev.id}`}>
                                                <BPCheckbox
                                                    label={ev.name}
                                                    onChange={(evt, data) => {
                                                        this.setState({
                                                            ...this.state,
                                                            evSystems: { ...this.state.evSystems, [ev.id]: this.state.evSystems[ev.id].map(s => { s.selected = data.checked; return s; }) },
                                                        })
                                                    }}></BPCheckbox>
                                            </TableHeaderCell>
                                        })}
                                        {uniqueSelectedContributros.map(ev => {
                                            return <TableHeaderCell key={`hc${ev.id}`}>
                                                <BPCheckbox
                                                    label={ev.name}
                                                    onChange={(evt, data) => {
                                                        this.setState({
                                                            ...this.state,
                                                            contrSystems: { ...this.state.contrSystems, [ev.id]: this.state.contrSystems[ev.id].map(s => { s.selected = data.checked; return s; }) },
                                                        })
                                                    }}></BPCheckbox>
                                            </TableHeaderCell>
                                        })}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {allSystems.map(sysName => {
                                        return <TableRow key={`sys${sysName}`}>
                                            <TableCell>
                                                <Checkbox
                                                    label={sysName}
                                                    checked={this.state.allSelectedSystems.indexOf(sysName) > -1}
                                                    onChange={(evt, data) => {
                                                        this.setState({
                                                            ...this.state,
                                                            allSelectedSystems: data.checked ? [...this.state.allSelectedSystems, sysName] : this.state.allSelectedSystems.filter(x => x != sysName),
                                                            contrSystems: Object.entries(this.state.contrSystems).reduce((acc, entry) => ({
                                                                ...acc,
                                                                [entry[0]]: entry[1].map(s => {
                                                                    s.selected = s.name == sysName ? s.selected = data.checked : s.selected;
                                                                    return s;
                                                                })
                                                            }), {}),
                                                            evSystems: Object.entries(this.state.evSystems).reduce((acc, entry) => ({
                                                                ...acc,
                                                                [entry[0]]: entry[1].map(s => {
                                                                    s.selected = s.name == sysName ? s.selected = data.checked : s.selected;
                                                                    return s;
                                                                })
                                                            }), {}),
                                                        })
                                                    }}></Checkbox>
                                            </TableCell>
                                            {/* {selectedEvidence.map(ev => { */}
                                            {Object.entries(this.state.evSystems).map(d => { return { id: d[0], systems: d[1].filter(s => s.selected).map(s => s.name), ev: d[1] } }).map(ev => {
                                                return <TableCell key={`ev_${ev.id}_${sysName}`}><Checkbox
                                                    disabled={this.state.evSystems[ev.id].findIndex(s => s.name == sysName) == -1}
                                                    checked={(ev.ev.find(s => s.name == sysName)?.selected)}
                                                    onChange={(async (evt, value) => {
                                                        let t = ev.ev.find(s => s.name == sysName);
                                                        if (t)
                                                            t.selected = value.checked;
                                                        await setFieldValue("evidence", values.evidence);
                                                    })}
                                                ></Checkbox></TableCell>
                                            })}
                                            {Object.entries(this.state.contrSystems).map(d => { return { id: d[0], systems: d[1].filter(s => s.selected).map(s => s.name), ev: d[1] } }).map(ev => {
                                                return <TableCell key={`contr_${ev.id}_${sysName}`}><Checkbox
                                                    disabled={this.state.contrSystems[ev.id].findIndex(s => s.name == sysName) == -1}
                                                    checked={(ev.ev.find(s => s.name == sysName)?.selected)}
                                                    onChange={(async (evt, value) => {
                                                        let t = ev.ev.find(s => s.name == sysName);
                                                        if (t)
                                                            t.selected = value.checked;

                                                        await setFieldValue("hp", values.hp);
                                                        await setFieldValue("hd", values.hd);
                                                    })}
                                                ></Checkbox></TableCell>
                                            })}
                                        </TableRow>
                                    })}
                                </TableBody>
                            </Table>
                        }
                    </Segment>
                }

                {Object.keys(errors).length > 0 &&
                    <Message negative>
                        <MessageHeader>{t.caseRun.errorsOnForm}</MessageHeader>
                        <MessageList>
                            {Object.keys(errors).map((k) => (<MessageItem key={k}>{errors[k]}</MessageItem>))}
                        </MessageList>
                    </Message>
                }
                <Segment basic clearing>
                    <BPButton floated="right" type="submit" positive primary>{t.caseRun.next}</BPButton>
                </Segment>
            </Form>}</TranslationContext.Consumer>);
    };

    onSubmit = (values: MaxLrFormType, bag) => {
        values.sampleSystems = Object.keys(this.state.contrSystems).map(key => { return { id: parseInt(key), systems: this.state.contrSystems[parseInt(key)].filter(s => s.selected).map(s => { return { name: s.name, selected: s.selected } }), } as CaseRunCreateEvidenceModelWithSystems })
        values.evidenceSystems = Object.keys(this.state.evSystems).map(key => { return { id: parseInt(key), systems: this.state.evSystems[parseInt(key)].filter(s => s.selected).map(s => { return { name: s.name, selected: s.selected } }), } as CaseRunCreateEvidenceModelWithSystems })

        this.props.onComplete(values);
        // this.props.router.history.push("/parameters");
    };

    render() {
        return (
            <Formik innerRef={this.form} enableReinitialize={true} initialValues={this.state.initialValues} onSubmit={this.onSubmit} validationSchema={!this.state.isRangeOfContributors ? this.InformactionMaxLrValidationSchema : this.InformactionMaxLrRangeValidationSchema}>
                {(props) => {
                    return this.formRender(props)
                }}
            </Formik>
        );
    }
}